import React, { Component } from "react";
import style from "./addManagers.module.css";
import { connect } from "react-redux";

interface AddManagersState {
}
interface AddManagersProps {  
}
export  class AddManagers extends Component<AddManagersProps, AddManagersState> {
  constructor(props: AddManagersProps) {
    super(props);
    this.state = {      
    };
  }

  componentDidMount(): void {
  }    
  render() {    
    const {  } = this.props;
    const {  } = this.state;
    return (
      <div>
        Add Hotesl
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({  
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(AddManagers);